import React, { type Dispatch, type RefObject, type SetStateAction, forwardRef, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { platform } from 'reactApp/appHelpers/configHelpers';
import { isRebrandingQuotaLanding } from 'reactApp/appHelpers/featuresHelpers';
import { sendQuotaGa } from 'reactApp/sections/QuotaLanding/QuotaLanding.helpers';
import { FloatingTooltip } from 'reactApp/ui/FloatingTooltip/FloatingTooltip';
import { ETooltipAppearance, ETooltipPlacement, ETooltipSize } from 'reactApp/ui/FloatingTooltip/FloatingTooltip.types';
import { sendXray } from 'reactApp/utils/ga';

import styles from './FamilySpaceUpsaleTooltip.css';

export const FAMILY_SPACE_UPSALE_TOOLTIP_ID = 'family-space-tooltip';
export const FAMILY_SPACE_UPSALE_TOOLTIP_SHOWN = `${FAMILY_SPACE_UPSALE_TOOLTIP_ID}-shown`;

const sendRadar = (action: 'view' | 'click' | 'close') => {
    sendXray(['family_space_tooltip', platform, action]);
    sendQuotaGa({ action: 'tooltip_family_space', label: action });
};

export const FamilySpaceUpsaleTooltip = forwardRef<HTMLDivElement, { onClose?: Dispatch<SetStateAction<boolean>> }>(({ onClose }, ref) => {
    const dispatch = useDispatch();

    const handleOnShow = useCallback(() => {
        sendRadar('view');
    }, [dispatch]);

    const handleClose = useCallback(() => {
        onClose?.(false);
        sendRadar('close');
    }, [dispatch]);

    return (
        <FloatingTooltip
            target={ref as RefObject<HTMLDivElement>}
            placement={ETooltipPlacement.topEnd}
            appearance={ETooltipAppearance.darkInverse}
            size={ETooltipSize.medium}
            onShow={handleOnShow}
            onClose={handleClose}
            allowFlip={false}
            topOffset={15}
            leftOffset={54}
            closeOnOutsideClick={false}
            qaId="family-space-upsale-tooltip"
            usePortal
            belowSticky
            closeOnScroll
            isRebrandingQuotaLanding={isRebrandingQuotaLanding}
            className={styles.familySpaceUpsaleTooltip}
        >
            <div className={styles.root}>
                <div className={styles.title}> 4 подписки — по цене одной 🔥</div>
                <div className={styles.text}>
                    Пригласите ещё троих близких: будет <br />в 4 раза больше места для семьи
                </div>
            </div>
        </FloatingTooltip>
    );
});

FamilySpaceUpsaleTooltip.displayName = 'FamilySpaceUpsaleTooltip';
